import React, { Component } from 'react';
import Alert from 'components/alerts/Alert/Alert';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { trimUserInput } from '../../../../utils/formHelpers';
import { allowAdminAccess } from '../../../../actions/Teacher/helpActions';

import './style.css';

const validate = formProps => {
  const errors = {};

  if (!formProps.email) {
    errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formProps.email)) {
    errors.email = 'Invalid email address';
  }

  return errors;
};

// TODO: pretty sure this renderField code is in many place, DRY
const renderField = ({
  input,
  label,
  type,
  disabled,
  meta: { touched, error, warning }
}) => {
  let hasStatus = null;
  let message = null;

  // remove touched from first two tests to
  // force form validation on initial load
  if (touched && error) {
    hasStatus = 'danger';
    message = error;
  } else if (touched && warning) {
    hasStatus = 'warning';
    message = warning;
  } else if (touched) {
    hasStatus = 'success';
    message = null;
  } else {
    hasStatus = null;
    message = null;
  }

  return (
    <div className={`form-group ${hasStatus ? 'has-' + hasStatus : ''}`}>
      <div className={`input-wrapper rounded  ${hasStatus ? 'has-' + hasStatus : ''}`}>
        <div className="text-left px-4">
          <small>{label}</small>
        </div>
        <input
          id={input.name}
          className="form-control form-control-danger form-control-warning form-control-success border-0 px-4"
          {...input}
          disabled={disabled}
          type={type}
        />
      </div>
      {message ? (
        <div className="form-control-feedback">
          <small>{message}</small>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

class TeacherSettingsHelp extends Component {
  handleFormSubmit = (values) => {
    // clean up any user input
    const userInput = trimUserInput(values);

    // pick off the values we want
    const { email } = userInput;

    return new Promise((resolve, reject) => {
      this.props.allowAdminAccess(
        email,
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      );
    }).catch(ex => {
      throw new SubmissionError(ex);
    });
  }

  renderFormError(error) {
    return (
      <Alert className="UpdateUserProfileFormError mb-4" alertType="danger">
        {// if the error is a string, return it,
        // otherwise build the error message
          typeof error === 'string' ? error : `${error.status}: ${error.statusText}`
        }
      </Alert>
    );
  }

  render() {
    const {
      error, handleSubmit, pristine, submitting, submitSucceeded
    } = this.props;

    return submitSucceeded ? (
      <p>We&#39;ve have sent an auth code to the email</p>
    ) : (
      <div className="teacher-settings-profile__section teacher-profile-information mb-4 p-4 p-md-4 p-lg-5">
        <div className="teacher-profile-information__content">
          <h4 className="mb-4">Allow Rype Admin Access</h4>
          <form className="HelpForm form" onSubmit={handleSubmit(this.handleFormSubmit)}>
            <Field
              name="email"
              component={renderField}
              type="email"
              label="Email"
              placeholder="Email"
            />
            <button
              disabled={submitting || pristine}
              onClick={this.allowAdminAccess}
              type="submit"
              className="btn btn-primary btn-lg btn-blue btn-cursor btn-teacher-dashboard"
            >
              Allow
            </button>

            {// if an error exists, render an Alert
              error && <p className="text-danger my-2">{error}</p>
            }
          </form>
        </div>
      </div>
    );
  }
}

export default compose(
  connect(
    null,
    { allowAdminAccess }
  ),
  reduxForm({ form: 'teacherAllowAdminAccessForm', validate })
)(TeacherSettingsHelp);



// WEBPACK FOOTER //
// ./src/pages/teacher/Settings/Help/index.js